import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Table } from '../../components/ui/Table';
import { Badge } from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { programs } from '../../data/mockData';
import { Plus, Search, Filter, FileText } from 'lucide-react';
interface ProgramListProps {
  onCreateClick: () => void;
  onDetailClick: (id: string) => void;
}
export function ProgramList({
  onCreateClick,
  onDetailClick
}: ProgramListProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const filteredPrograms = programs.filter(p => {
    const matchesSearch = p.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'All' || p.status === statusFilter;
    return matchesSearch && matchesStatus;
  });
  const columns = [{
    header: 'Nama Program',
    accessor: (item: any) => <div className="min-w-0" data-id="element-669">
          <div className="font-semibold text-gray-900 truncate" data-id="element-670">
            {item.name}
          </div>
          <div className="text-xs text-gray-500 mt-0.5" data-id="element-671">{item.id}</div>
        </div>
  }, {
    header: 'Tipe',
    accessor: (item: any) => <Badge variant="info" data-id="element-672">{item.type}</Badge>
  }, {
    header: 'Periode',
    accessor: 'period',
    className: 'hidden md:table-cell'
  }, {
    header: 'Status',
    accessor: (item: any) => {
      const variants: any = {
        Running: 'success',
        Approved: 'info',
        Draft: 'neutral',
        Closed: 'neutral'
      };
      return <Badge variant={variants[item.status] || 'neutral'} data-id="element-673">
            {item.status}
          </Badge>;
    }
  }, {
    header: 'Realisasi / Kuota',
    accessor: (item: any) => <div className="w-40" data-id="element-674">
          <div className="flex justify-between items-center text-xs mb-1.5" data-id="element-675">
            <span className="font-semibold text-gray-900" data-id="element-676">
              {Math.round(item.realization / item.quota * 100)}%
            </span>
            <span className="text-gray-500" data-id="element-677">
              {(item.realization / 1000).toFixed(0)}k /{' '}
              {(item.quota / 1000).toFixed(0)}k
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden" data-id="element-678">
            <div className="bg-bulog-blue h-2 rounded-full transition-all duration-500" style={{
          width: `${Math.min(item.realization / item.quota * 100, 100)}%`
        }} data-id="element-679"></div>
          </div>
        </div>,
    className: 'hidden lg:table-cell'
  }, {
    header: 'PIC',
    accessor: 'pic',
    className: 'hidden xl:table-cell'
  }];
  return <div className="space-y-6" data-id="element-680">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-681">
        <div data-id="element-682">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-683">
            Program & Penugasan
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-684">
            Kelola program pemerintah (SPHP, Bantuan Pangan, CPP)
          </p>
        </div>
        <Button onClick={onCreateClick} icon={<Plus size={18} data-id="element-686" />} className="w-full sm:w-auto" data-id="element-685">
          Buat Program Baru
        </Button>
      </div>

      <Card data-id="element-687">
        <div className="flex flex-col sm:flex-row gap-4 mb-6" data-id="element-688">
          <div className="flex-1" data-id="element-689">
            <Input placeholder="Cari nama program..." leftIcon={<Search size={18} data-id="element-691" />} value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-690" />
          </div>
          <div className="w-full sm:w-48" data-id="element-692">
            <Select options={[{
            value: 'All',
            label: 'Semua Status'
          }, {
            value: 'Running',
            label: 'Running'
          }, {
            value: 'Approved',
            label: 'Approved'
          }, {
            value: 'Draft',
            label: 'Draft'
          }, {
            value: 'Closed',
            label: 'Closed'
          }]} value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-693" />
          </div>
          <Button variant="outline" icon={<Filter size={18} data-id="element-695" />} className="w-full sm:w-auto" data-id="element-694">
            Filter
          </Button>
        </div>

        <Table data={filteredPrograms} columns={columns} keyExtractor={item => item.id} onRowClick={item => onDetailClick(item.id)} data-id="element-696" />
      </Card>
    </div>;
}